var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .premium-icon {\r\n        clip-path: url(#clip-Premium_Feature_White);\r\n      }\r\n\r\n      .premium-color {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Premium_Feature_White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Premium_Feature_White",
    "data-name": "Premium Feature \\u2013 White",
    className: "premium-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "premium",
    transform: "translate(-6.356 0.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6005",
    "data-name": "Group 6005",
    transform: "translate(6.919 11.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6004",
    "data-name": "Group 6004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12749",
    "data-name": "Path 12749",
    className: "premium-color",
    d: "M25.121,306.427a1.148,1.148,0,0,0-1.576-.391l-3.706,1.893a1.148,1.148,0,0,0-.8-1.967h-3.48c-1.443,0-2.123-1.02-4.555-1.02v-.51H6.919v7.653H11v-2.041s.664.46,1.531,1.02a2.563,2.563,0,0,0,1.726.51h3.8a3.528,3.528,0,0,0,1.48-.458c.527-.255,5.192-3.112,5.192-3.112A1.148,1.148,0,0,0,25.121,306.427ZM9.47,310.553H8.45v-4.592H9.47Z",
    transform: "translate(-6.919 -304.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6007",
    "data-name": "Group 6007",
    transform: "translate(10.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6006",
    "data-name": "Group 6006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12750",
    "data-name": "Path 12750",
    className: "premium-color",
    d: "M114.491,4.092l-4.108-.268L108.859,0l-1.525,3.824-4.108.268,3.166,2.632-1.014,3.99,3.481-2.2,3.481,2.2-1.014-3.99Z",
    transform: "translate(-103.226)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumFeature);
export default __webpack_public_path__ + "static/media/PremiumFeature.4dcbbff1f51370da88b6d6358bf231b1.svg";
export { ForwardRef as ReactComponent };